import BaseObjectDirective from './BaseObjectDirective';

/**
 * Controller for the scatter graph object directive.
 * Extends the BaseObjectDirective class.
 */
export class AsfScatterGraphObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfScatterGraphObjectCtrl.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $injector - Angular injector service.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $rootScope - Angular root scope.
     * @param {Object} $routeParams - Angular route parameters.
     * @param {Object} TaskDataService - Service for fetching task context.
     * @param {Object} $signals - Signal service.
     * @param {Object} $timeout - Angular timeout service.
     * @param {Object} ObjectInstanceRegistrationService - Service for registering object instances.
     * @param {Object} $translate - Angular translate service.
     * @param {Object} TaskInfoService - Service for fetching task information.
     * @param {Object} $q - Angular promise service.
     * @param {Object} SheetLoadedService - Service for handling sheet loading.
     */
    constructor($scope, $injector, $uibModal, $rootScope, $routeParams, TaskDataService, $signals, $timeout, ObjectInstanceRegistrationService, $translate, TaskInfoService, $q, SheetLoadedService) {
        super();
        $injector.invoke(this.init, this, {$scope: $scope});
        this.debugId = "sg" + Math.random();

        const taskContext = TaskDataService.fetchContext();
        const taskLanguage = TaskInfoService.getTaskInfo().getLanguageCode();

        $scope.isCMS = $rootScope.isCMS && $rootScope.isPreview;
        $scope.prefsMode = false;
        $scope.taskuuid = $routeParams.taskUUID;
        $scope.objectUUID = $scope.contentObject.getUUID();

        $scope.scatterGraphURL = "/iframe-tools/scatter-graph/index.html?uuid=" + $scope.objectUUID;

        $scope.translation = {
            "GRAPH-SETTINGS": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.GRAPH-SETTINGS"),
            "GRAPH-TITLE": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.GRAPH-TITLE"),
            "X-LABEL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.X-LABEL"),
            "Y-LABEL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.Y-LABEL"),
            "X-DECIMALS": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.X-DECIMALS"),
            "Y-DECIMALS": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.Y-DECIMALS"),
            "X-MINIMUM": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.X-MINIMUM"),
            "Y-MINIMUM": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.Y-MINIMUM"),
            "X-INCREMENT": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.X-INCREMENT"),
            "Y-INCREMENT": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.Y-INCREMENT"),
            "FOOTER-CLOSE": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.FOOTER-CLOSE"),
            "FOOTER-SAVE": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.FOOTER-SAVE"),
            "LINE-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.LINE-TOOL"),
            "RECTANGLE-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.RECTANGLE-TOOL"),
            "DIAMOND-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.DIAMOND-TOOL"),
            "CIRCLE-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.CIRCLE-TOOL"),
            "TRIANGLE-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.TRIANGLE-TOOL"),
            "POLYGON-TOOL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.POLYGON-TOOL"),
            "LABEL-OUTLIER": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.LABEL-OUTLIER"),
            "LABEL-REGION": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.LABEL-REGION"),
            "CLOSE": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.CLOSE"),
            "SAVE-CHANGES": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.SAVE-CHANGES"),
            "OPEN-GRAPH-SETTINGS": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.OPEN-GRAPH-SETTINGS"),
            "INSTRUCTIONS-LABEL": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.INSTRUCTIONS-LABEL"),
            "INSTRUCTIONS-TEXT": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.INSTRUCTIONS-TEXT"),
            "INSTRUCTIONS-BUTTON": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.INSTRUCTIONS-BUTTON"),
            "OUTLIER": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.OUTLIER"),
            "REGION": $translate.instant("CONTENTOBJECT.SCATTERGRAPH.REGION")
        };

        let dataToLoadAfterIframeReady = null;

        $signals.on('iFrameReady', function(objectUUID) {
            if (typeof objectUUID != 'undefined' && objectUUID == $scope.objectUUID) {
                $scope.scatterGraphObject = ObjectInstanceRegistrationService.getObjectByUUID($scope.objectUUID);
                if (dataToLoadAfterIframeReady !== null) {
                    $scope.scatterGraphObject.loadScatterGraph(dataToLoadAfterIframeReady);
                }
                $scope.scatterGraphObject.translateScatterGraph($scope.translation);
                $scope.scatterGraphObject.setLanguage(taskLanguage);
            }
        });

        this.setResponseFill(function (attachment) {
            if (!attachment.chartData) return;

            console.log("Filling: ", attachment.chartData);
            dataToLoadAfterIframeReady = attachment.chartData;
            if ($scope.scatterGraphObject) {
                $scope.scatterGraphObject.loadScatterGraph(attachment.chartData);
                $scope.scatterGraphObject.translateScatterGraph($scope.translation);
            }
        });

        this.setResponseCollect(function (attachment) {
            console.log("Collecting");
            attachment.chartData = $scope.scatterGraphObject.saveScatterGraph();
            console.log("Collecting: ", attachment);

            if (attachment.chartData.graphics.length > 0) {
                return true;
            }
        });

        $scope.iFrameStyle = {
            'width': '900px',
            'height': '800px',
            'border': '0',
            'overflow': 'hidden',
            'background-color': '#FFFFFF'
        };

        $scope.initPreferences = function() {
            const setTitle = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().setTitle : undefined);
            const setXLabel = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().setXLabel : undefined);
            const setYLabel = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().setYLabel : undefined);
            const includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : false);

            $scope.$watch(function() { return $scope.preferencesValues; }, function(val1, val2) {
                if (val1 == val2)
                    return;
                const preferences = $scope.contentObject.getPreferences();

                console.log('preferences', preferences);

                angular.forEach($scope.preferencesValues, function(value, key) {
                    preferences[key] = value;
                    if (angular.isFunction($scope.scatterGraphObject[key])) {
                        $scope.scatterGraphObject[key](value);
                    }
                });
                $scope.contentObject.setPreferences(preferences);
            }, true);

            $scope.preferencesValues = {};
            $scope.preferencesValues['setTitle'] = setTitle;
            $scope.preferencesValues['setXLabel'] = setXLabel;
            $scope.preferencesValues['setYLabel'] = setYLabel;
            $scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : false;

            console.log('$scope.preferencesValues', $scope.preferencesValues);

            $scope.preferences = [
                {
                    '01-title': [
                        {'type': 'input', 'name': 'Title:', 'valueKey': 'setTitle'}
                    ],
                    '02-xaxis': [
                        {'type': 'input', 'name': 'Label for X Axis:', 'valueKey': 'setXLabel'}
                    ],
                    '03-yaxis': [
                        {'type': 'input', 'name': 'Label for Y Axis:', 'valueKey': 'setYLabel'}
                    ],
                    '11-includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ]
                },
            ];
        };

        window.IB.iFrameDelegates[$scope.objectUUID] = (function(_uuid) {
            return {
                getConfig: function() {
                    return {
                        setTitle: $scope.contentObject.getPreferences().setTitle,
                        setXLabel: $scope.contentObject.getPreferences().setXLabel,
                        setYLabel: $scope.contentObject.getPreferences().setYLabel
                    };
                }
            };
        })($scope.objectUUID);

        const _tmp = $scope.resetChanges;
        $scope.resetChanges = function () {
            _tmp();
            console.log("override # <" + $scope.contentObject.getUUID() + "> resetChanges()");
            $scope.initPreferences();
        };

        $scope.initPreferences();

        const _d = $q.defer();
        SheetLoadedService.wait(_d.promise, 'scattergraph');
        $timeout(function () {
            if ($scope.$parent.element.find('iframe').length > 0) {
                $scope.$parent.element.find('iframe').load(function () {
                    _d.resolve('scattergraph');
                });
            } else {
                _d.resolve('scattergraph');
            }
        });
    }
}

/**
 * Registers the scatter graph object directive.
 * @param {Object} module - Angular module.
 */
export default function registerAsfScattergraphObjectDirective(module) {
    module.directive('asfScattergraphObject', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: "/views/ib/contentobjects/scattergraph.html",
            controller: AsfScatterGraphObjectCtrl
        };
    });

    registerContentObject(module);
}

/**
 * Registers the content object.
 * @param {Object} module - Angular module.
 */
function registerContentObject(module) {
    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        const obj = [{
            "uuid": "",
            "content": "",
            "objectType": "scattergraph",
            "type": "contentObject",
            "contentReference": false,
            "preferences": {
                "setTitle": undefined,
                "setXLabel": undefined,
                "setYLabel": undefined,
                "includedInPDF": true
            }
        }];
        const objProperties = {
            type: "scattergraph",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.SCATTER-GRAPH.LABEL',
            cssClass: "new-scatter-graph-object",
            icon: "cms/icon-scatter.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.SCATTER-GRAPH.DESCRIPTION',
            group: {
                id: 3
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}